// extracted by mini-css-extract-plugin
export var component = "TermList-module--component--NVH01";
export var taxonomy = "TermList-module--taxonomy--87wFL";